const SET_SHOW_UPLOAD_AUDIO_MODAL = 'SET_SHOW_UPLOAD_AUDIO_MODAL'
const SET_UPLOADING_AUDIO_DONE = 'SET_UPLOADING_AUDIO_DONE'
const SET_UPLOAD_AUDIO_ERROR = 'SET_UPLOAD_AUDIO_ERROR'
const SET_IS_UPLOADING_AUDIO = 'SET_IS_UPLOADING_AUDIO'

const _state = {
  isUploadAudioModalVisible: false,
  isUploadingAudioDone: false,
  uploadAudioError: null,
  isUploadingAudio: false,
}

const getters = {
  isUploadAudioModalVisible(state) {
    return state.isUploadAudioModalVisible
  },
  isUploadingAudioDone(state) {
    return state.isUploadingAudioDone
  },
  uploadAudioError(state) {
    return state.uploadAudioError
  },
  isUploadingAudio(state) {
    return state.isUploadingAudio
  },
}

const actions = {
  setShowUploadAudioModalAction({ commit }, value) {
    commit(SET_SHOW_UPLOAD_AUDIO_MODAL, value)
  },
  setIsUploadingAudioDoneAction({ commit }, value) {
    commit(SET_UPLOADING_AUDIO_DONE, value)
  },
  setUploadAudioErrorAction({ commit }, value) {
    commit(SET_UPLOAD_AUDIO_ERROR, value)
  },
  setIsUploadingAudioAction({ commit }, value) {
    commit(SET_IS_UPLOADING_AUDIO, value)
  },
}

const mutations = {
  [SET_SHOW_UPLOAD_AUDIO_MODAL](state, value) {
    state.isUploadAudioModalVisible = value
  },
  [SET_UPLOADING_AUDIO_DONE](state, value) {
    state.isUploadingAudioDone = value
  },
  [SET_UPLOAD_AUDIO_ERROR](state, value) {
    state.uploadAudioError = value
  },
  [SET_IS_UPLOADING_AUDIO](state, value) {
    state.isUploadingAudio = value
  },
}

const audioUploader = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default audioUploader
